import {
  useCartContext
} from "@/context/cart"
import {
  gql,
  useQuery
} from "@apollo/client"
import {
  ExtendedCart
} from "./new-minicart-components/cart-item"

export const CROSS_DATA_QUERY = gql`
query CartCrossData($cartId: String!) {
  cart(cart_id: $cartId) {
             cross_sells_products {
            amazon_url
            attribute_set_id
            best_seller
            canonical_url
            color
            country_of_manufacture
            created_at
            gift_message_available
            high_to_low
            hover_image
            id
            low_to_high
            manufacturer
            meta_description
            meta_keyword
            meta_title
            most_reviews
            name
            new_from_date
            new_to_date
            only_x_left_in_stock
            options_container
            package_quantity
            product_asin
            product_mark
            rating_summary
            review_count
            seo_rich_snippets
            shipingtypes
            size
            sku
            special_from_date
            special_price
            special_to_date
            stock_status
            swatch_image
            tier_price
            type_id
            uid
            updated_at
            url_key
            url_path
            url_suffix
            video_url
            price_range {
                maximum_price {
                    discount {
                        amount_off
                        percent_off
                    }
                    final_price {
                        currency
                        value
                    }
                }
                minimum_price {
                    discount {
                        amount_off
                        percent_off
                    }
                    final_price {
                        currency
                        value
                    }
                    fixed_product_taxes {
                        label
                    }
                    regular_price {
                        currency
                        value
                    }
                }
            }
            small_image {
                disabled
                label
                position
                url
            }
            image {
                disabled
                label
                position
                url
            }
        }
  }
}
`

export const useCrossData = ({
  open,
  productList
}:{
  open: boolean
  productList: any[]
}) => {
  const hasProduct = Array.isArray(productList) && productList.length > 0


  const [{
    cartId 
  }] = useCartContext()

  const {
    data,
    loading
  } = useQuery<{ cart: ExtendedCart}>(CROSS_DATA_QUERY, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "no-cache",
    variables: {
      cartId,
    },
    skip: !cartId || !open,
    errorPolicy: "all",
  })

  const crossData = data?.cart?.cross_sells_products || []

  return {
    crossData,
    loading
  }
}

